import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { StoreProvider } from "./context/StoreContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import POS from "./pages/POS";
import RepairTickets from "./pages/RepairTickets";
import NewRepairTicket from "./pages/NewRepairTicket";
import RepairTicketDetail from "./pages/RepairTicketDetail";
import Inventory from "./pages/Inventory";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Sales from "./pages/Sales";
import SaleDetail from "./pages/SaleDetail";
import Settings from "./pages/Settings";
import MyProfile from "./pages/MyProfile";
import SettingsHub from "./pages/settings/SettingsHub";
import {
  GeneralSettingsPage, StoresSettingsPage, UsersSettingsPage, PrintersSettingsPage,
  TemplatesSettingsPage, DataSettingsPage, AuditSettingsPage, MessagesSettingsPage,
  TyroSettingsPage, SmsSettingsPage, EmailSettingsPage, PrintNodeSettingsPage,
  GooglePlacesSettingsPage, BookingWebhookSettingsPage, MigrateSettingsPage, HistoricalGrossSettingsPage,
  WebsiteCatalogSyncPage,
} from "./pages/settings/SettingsSubPages";
import Bookings from "./pages/Bookings";
import TradeIns from "./pages/TradeIns";
import Reports from "./pages/Reports";
import ResetPassword from "./pages/ResetPassword";
import Till from "./pages/Till";
import StoreFavicon from "./components/StoreFavicon";
import PayInvoice from "./pages/PayInvoice";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <StoreProvider>
          <StoreFavicon />
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pay/:token" element={<PayInvoice />} />
            <Route path="/online-invoices" element={<Navigate to="/invoices?tab=online" replace />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/pos" element={<ProtectedRoute><POS /></ProtectedRoute>} />
            <Route path="/repairs" element={<ProtectedRoute><RepairTickets /></ProtectedRoute>} />
            <Route path="/repairs/new" element={<ProtectedRoute><NewRepairTicket /></ProtectedRoute>} />
            <Route path="/repairs/:id" element={<ProtectedRoute><RepairTicketDetail /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/customers/:id" element={<ProtectedRoute><CustomerDetail /></ProtectedRoute>} />
            <Route path="/sales" element={<Navigate to="/invoices" replace />} />
            <Route path="/invoices" element={<ProtectedRoute><Sales /></ProtectedRoute>} />
            <Route path="/sales/:id" element={<ProtectedRoute><SaleDetail /></ProtectedRoute>} />
            <Route path="/invoices/:id" element={<ProtectedRoute><SaleDetail /></ProtectedRoute>} />
            <Route path="/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
            <Route path="/trade-ins" element={<ProtectedRoute><TradeIns /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/till" element={<ProtectedRoute><Till /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute adminOnly><SettingsHub /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
            <Route path="/settings/general" element={<ProtectedRoute adminOnly><GeneralSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/stores" element={<ProtectedRoute adminOnly><StoresSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/users" element={<ProtectedRoute adminOnly><UsersSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/printers" element={<ProtectedRoute adminOnly><PrintersSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/templates" element={<ProtectedRoute adminOnly><TemplatesSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/messages" element={<ProtectedRoute adminOnly><MessagesSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/data" element={<ProtectedRoute adminOnly><DataSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/audit" element={<ProtectedRoute adminOnly><AuditSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/tyro" element={<ProtectedRoute adminOnly><TyroSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/sms" element={<ProtectedRoute adminOnly><SmsSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/email" element={<ProtectedRoute adminOnly><EmailSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/printnode" element={<ProtectedRoute adminOnly><PrintNodeSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/google-places" element={<ProtectedRoute adminOnly><GooglePlacesSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/booking-webhook" element={<ProtectedRoute adminOnly><BookingWebhookSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/website-catalog" element={<ProtectedRoute adminOnly><WebsiteCatalogSyncPage /></ProtectedRoute>} />
            <Route path="/settings/migrate" element={<ProtectedRoute adminOnly><MigrateSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/historical-gross" element={<ProtectedRoute adminOnly><HistoricalGrossSettingsPage /></ProtectedRoute>} />
            <Route path="/settings/legacy" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        </StoreProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
